export function citationResource() {
  const isAdmin = document.querySelector("#bx-panel");
  if (!isAdmin) {
    document.addEventListener(
      "copy",
      function (e) {
        const selection = window.getSelection();
        const copiedText = selection ? selection.toString() : "";

        if (copiedText.length > 300) {
          const fullURL = window.location.href;
          const language = document.documentElement.lang || "ru";

          const sourceTextOptions = {
            ru: "Подробнее на сайте РАНХиГС",
            en: "Read more on the RANEPA website",
            zh: "详见俄罗斯总统国民经济与国家行政学院官网",
          };

          const customPrefix =
            window.RANEPA_SOURCE_PREFIX ||
            sourceTextOptions[language] ||
            sourceTextOptions["ru"];

          const citationBlock = `\r\n\r\n${customPrefix} ${fullURL}`;
          const newText = copiedText + citationBlock;

          if (e.clipboardData) {
            e.clipboardData.setData("text/plain", newText);
            e.preventDefault();
          }
        }
      },
      { capture: true }
    );
  }
}
